import axios from 'axios';

const ROOT = 'api/v1/smworklist';

const SMWorklistApi = {
  getDataForSMWorklist(req, withLoader) {
    return axios.post(ROOT, req, { hideLoader: withLoader });
  },
  getWorkListSignedByPerGroupValuesForTable(patientEncounterIds, request) {
    return axios.post(`${ROOT}/table/signers-per-groups`, patientEncounterIds, {
      hideLoader: true,
      cancelToken: request.token
    });
  },
  getEncounterNamesBySsuIds(ssuIds, statuses) {
    return axios.post(
      `${ROOT}/encounter`,
      {
        ssuIds,
        statuses
      },
      { hideLoader: true }
    );
  },
  getCountOfReviewsBySsuIds(ssuIds) {
    return axios.post(`${ROOT}/count`, ssuIds, { hideLoader: false });
  },
  countLogsBySMStatus(ssuIds, logCode) {
    return axios.post(`api/v1/work-lists/logs/count-sm`, { ssuIds, logCode }, { hideLoader: false });
  },
  getLogsForSmWorkListByRequest(request, withLoader) {
    return axios.post(`api/v1/work-lists/logs/elements-sm`, request, { hideLoader: withLoader });
  },
  getLogsSignedByPerGroupValuesForTable(rowIdsToTemplateIds, logCode, request) {
    return axios.post(
      `api/v1/work-lists/logs/signers-per-groups`,
      { rowIdsToTemplateIds, logCode },
      {
        hideLoader: true,
        cancelToken: request.token
      }
    );
  },
  getEncounterNamesAndStudyNamesBySsuIds(ssuIds, statuses) {
    return axios.post(
      `${ROOT}/encounter-with-study`,
      {
        ssuIds,
        statuses
      },
      { hideLoader: false }
    );
  },
  getSMWorkListLogsSignedByFilterSignersAndSmReviewers(ssuIds, smStatuses, logCode) {
    return axios.post(
      `api/v1/work-lists/logs/filters/signers`,
      {
        ssuIds,
        smStatuses,
        piStatuses: [],
        logCode
      },
      { hideLoader: false }
    );
  },
  getSMWorkListSignedByFilterSignersAndSmReviewers(ssuIds, statuses) {
    return axios.post(
      `${ROOT}/signers`,
      {
        ssuIds,
        statuses
      },
      { hideLoader: true }
    );
  }
};

export default SMWorklistApi;
